import { useSnackbar } from 'notistack'
import { useCallback, useState } from 'react'
import { ApiReportTimelapseTrafficGetRequest, ReportApi } from '../../../api/generated/Api'
import { handleFileDownload, HttpContentDispositionHeader } from '../../../utils/HandleFileDownload'
import { GetApiConfig } from '../../auth/services/authService'

export const useTrafficTimelapseGetApi = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | undefined>(undefined)
  const { enqueueSnackbar } = useSnackbar()

  const download = useCallback(
    (request: ApiReportTimelapseTrafficGetRequest) => {
      if (isLoading) return

      setError(undefined)
      setIsLoading(true)

      new ReportApi(GetApiConfig())
        .apiReportTimelapseTrafficGet(request, HttpContentDispositionHeader)
        .then(handleFileDownload)
        .catch((e) => {
          setError(e)
          enqueueSnackbar('Failed to download traffic timelapse', { variant: 'error' })
        })
        .then((blob) => {
          setIsLoading(false)
        })
    },
    [isLoading, enqueueSnackbar],
  )

  return { isLoading, error, download }
}
